<template>
  <div class="list">
    <div class="header">
      <div class="l" />
      <div class="r">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dataChange"
        />
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @sortChange="sortChange"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, { registrationStatusList, distributionStatusList } from '@/config';

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      searchForm: {
        createTimeStart: '',
        createTimeEnd: '',
        pageNum: 1,
        pageSize: 10,
        sortType: null,
      },
      daterange: [],
      tabelData: {},
      tableColumn: [
        {
          key: 'registrationNo',
          label: '订单号',
          width: '200px',
          dataType: 'text',
        },
        {
          key: 'courseName',
          label: '课程名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agencyName',
          label: '机构构名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'payAmount',
          label: '支付金额',
          width: '80px',
          dataType: 'money',
        },
        {
          key: 'platformDistributionAmount',
          label: '分销(平台)',
          width: '80px',
          dataType: 'money',
        },
        {
          key: 'platformDistributionStatus',
          label: '状态(平台)',
          width: '120px',
          dataType: 'function',
          render: (key) => distributionStatusList.filter((item) => item.value === key),
        },
        {
          key: 'platformDistributionExtractTime',
          label: '提取时间(平台)',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'agencyDistributionAmount',
          label: '分销(机构)',
          width: '80px',
          dataType: 'money',
        },
        {
          key: 'agencyDistributionStatus',
          label: '状态(机构)',
          width: '120px',
          dataType: 'function',
          render: (key) => distributionStatusList.filter((item) => item.value === key),
        },
        {
          key: 'agencyDistributionExtractTime',
          label: '提取时间(机构)',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'studentDistributionAmount',
          label: '分销(学员)',
          width: '80px',
          dataType: 'money',
        },
        {
          key: 'studentDistributionStatus',
          label: '状态(学员)',
          width: '80px',
          dataType: 'function',
          render: (key) => distributionStatusList.filter((item) => item.value === key),
        },
        {
          key: 'studentDistributionExtractTime',
          label: '提取时间(学员)',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'teacherDistributionAmount',
          label: '分销(老师)',
          width: '80px',
          dataType: 'money',
        },
        {
          key: 'teacherDistributionStatus',
          label: '状态(老师)',
          width: '80px',
          dataType: 'function',
          render: (key) => distributionStatusList.filter((item) => item.value === key),
        },
        {
          key: 'teacherDistributionExtractTime',
          label: '提取时间(老师)',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'registrationStatus',
          label: '订单状态',
          width: '80px',
          dataType: 'function',
          renderProps: '',
          render: (key) => registrationStatusList.filter((item) => item.value === key),
        },
        {
          key: 'isRefund',
          label: '退款状态',
          width: '100px',
          dataType: 'component',
          renderProps: { [types.IS_REFUND]: '未退款', [types.IS_NO_REFUND]: '已退款', successKey: types.IS_REFUND },
          render: () => 'status',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: '180px',
          dataType: 'time',
          sortable: 'custom',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.distribution.distributionList(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        createTime: {
          ascending: 10,
          descending: 20,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // 时间选择
    dataChange(vals) {
      if (vals) {
        const [createTimeStart, createTimeEnd] = vals;
        this.searchForm.createTimeStart = createTimeStart;
        this.searchForm.createTimeEnd = createTimeEnd;
      } else {
        this.searchForm.createTimeStart = '';
        this.searchForm.createTimeEnd = '';
      }
      this.getList();
    },
  },
};
</script>
